import { Skeleton, cn } from "ui";

type SkeletonFieldProps = {
  className?: string;
  /** Label width class. */
  labelWidth?: string;
};

export const SkeletonField = ({
  className,
  labelWidth = "w-24",
}: SkeletonFieldProps) => (
  <div className={cn("flex flex-col gap-2", className)}>
    <Skeleton className={cn("h-3", labelWidth)} />
    <Skeleton className="h-10 w-full rounded-md" />
  </div>
);
